import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useI18n } from "@/i18n";

// Reusable create/edit dialog driven by a fields config.
// fields: [{ name, label, type: "text"|"select", options?: [{value,label}] }]
export default function EntityDialog({ open, onOpenChange, title, fields, initial, onSubmit, submitLabel }) {
  const { t } = useI18n();
  const [v, setV] = useState(initial || {});
  const [busy, setBusy] = useState(false);
  useEffect(() => { setV(initial || {}); }, [initial, open]);
  const set = (k, val) => setV((x) => ({ ...x, [k]: val }));
  const submit = async () => {
    setBusy(true);
    try { await onSubmit(v); onOpenChange(false); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="entity-dialog">
        <DialogHeader><DialogTitle>{title}</DialogTitle>
          <DialogDescription className="sr-only">{title}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          {fields.map((f) => (
            <div key={f.name} className="space-y-1">
              <Label className="text-xs text-slate-500">{f.label}</Label>
              {f.type === "select" ? (
                <Select value={v[f.name] || ""} onValueChange={(val) => set(f.name, val)}>
                  <SelectTrigger data-testid={`field-${f.name}`}><SelectValue placeholder={f.label} /></SelectTrigger>
                  <SelectContent>{(f.options || []).map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent>
                </Select>
              ) : (
                <Input data-testid={`field-${f.name}`} type={f.inputType || "text"} value={v[f.name] || ""} onChange={(e) => set(f.name, e.target.value)} />
              )}
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t("cancel")}</Button>
          <Button onClick={submit} disabled={busy} data-testid="dialog-submit">{submitLabel || t("save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
